import features from '../../shared/features'

const EVENTS = [
  'click',
  'contextmenu',
  'dblclick',
  'mousedown',
  'mouseenter',
  'mouseleave',
  'mousemove',
  'mouseover',
  'mouseout',
  'mouseup',
  'keydown',
  'keypress',
  'keyup',
  'blur',
  'change',
  'focus',
  'focusin',
  'focusout',
  'input',
  'invalid',
  'reset',
  'search',
  'select',
  'submit',
  'drag',
  'dragend',
  'dragenter',
  'dragleave',
  'dragover',
  'dragstart',
  'drop',
  'copy',
  'cut',
  'paste',
  'mousewheel',
  'wheel',
  'touchcancel',
  'touchend',
  'touchmove',
  'touchstart',
]

export function stopAllEventsPropagation(element: HTMLElement): () => void {
  if (!element) {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return () => {}
  }

  const handler = (event: Event) => event.stopPropagation()
  const options = features().events.passiveSupported ? { passive: true, capture: false } : false

  EVENTS.forEach(eventName => element.addEventListener(eventName, handler, options))

  return () => {
    EVENTS.forEach(eventName => element.removeEventListener(eventName, handler))
  }
}

export function createEvent(type: string): Event {
  let event: Event
  if (typeof Event === 'function') {
    event = new Event(type, { cancelable: true })
  } else {
    event = document.createEvent('Event')
    event.initEvent(type, true, true)
  }

  return event
}

const EXCLUDE_SELECTOR = [
  'input',
  'fieldset',
  'button',
  'select',
  'textarea',
  '.input-rating',
  '.input-check',
  '.input-flag',
].join(',')

export function shouldIgnoreEvents(el: HTMLElement): boolean {
  return !!el.closest(EXCLUDE_SELECTOR)
}
